export default __webpack_public_path__ + "static/media/WalletConnect.c9c162e3.svg";